// ============================================
// 权限指令 v-permission
// ============================================

import store from '../store'

function checkPermission(el, binding) {
  const { value } = binding
  const permissions = store.getters.permissions

  // 管理员权限直接放行
  if (permissions.includes('*:*:*') || permissions.includes('*')) {
    return
  }

  if (value && value instanceof Array) {
    if (value.length > 0) {
      const hasPermission = permissions.some(p => value.includes(p))
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else if (value) {
    if (!permissions.includes(value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error('需要指定权限标识，如 v-permission="\'user:add\'"')
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
